import { useState } from 'react';

const WeightDropDown = (props) => { 

    let options = [{value: 'o', name: 'oz'},{value: 'g', name: 'g'},{value: 'k', name: 'kg'}]
    const url = props.url 
    var val = props.defaultWeight ? props.defaultWeight : 'o'
    if(props.preValue === 'Silver') {
        val = 'o'
    }

    const [oldValue, setOldValue] = useState(val);

    const fnChange = (e) => {
        setOldValue(e.target.value);
        props.handleChange(e.target.value, oldValue);
    }
    
    return (
            <select  className="form-control kg" defaultValue={val} 
            onChange={fnChange}>
                {options.map((item,key) => {
                    if(item.name === 'g' && url && url.includes('Silver'))
                        return null
                    return <option value={item.value} key={key}>{item.name}</option>
                })}
            </select>
    )
}

export default WeightDropDown;